var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeather = function SvgFeather(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.756 1.988a6.25 6.25 0 0 1 6.248 6.248c0 1.657-.659 3.245-1.83 4.416l.001.001-5.79 5.807a2.49 2.49 0 0 1-1.757.73h-6.97l-2.646 2.647a.6.6 0 1 1-.848-.849l2.648-2.647v-6.969c0-.658.261-1.29.726-1.755l5.8-5.799a6.25 6.25 0 0 1 4.418-1.83M9.422 15.427 6.86 17.99h5.768a1.28 1.28 0 0 0 .907-.377h.001l2.18-2.186zm6.334-12.24a5.05 5.05 0 0 0-3.57 1.479l-5.8 5.8c-.24.24-.375.566-.375.906v5.77l9.324-9.325a.6.6 0 0 1 .849.848l-5.563 5.563h6.29l2.413-2.421.001-.001a5.05 5.05 0 0 0-3.569-8.618"
  })));
};
export default SvgFeather;